import { MYSTERY_BOX_TYPE } from '@/types/shared/player-config'

// Import closed box images
import FreeBoxClosed from '@/assets/images/mystery-boxes/free-closed.webp'
import StarterBoxClosed from '@/assets/images/mystery-boxes/starter-closed.webp'
import PowerBoxClosed from '@/assets/images/mystery-boxes/power-closed.webp'
import MasterBoxClosed from '@/assets/images/mystery-boxes/master-closed.webp'
import EliteBoxClosed from '@/assets/images/mystery-boxes/elite-closed.webp'
import LegendaryBoxClosed from '@/assets/images/mystery-boxes/legendary-closed.webp'

// Import open box images
import FreeBoxOpen from '@/assets/images/mystery-boxes/free-open.webp'
import StarterBoxOpen from '@/assets/images/mystery-boxes/starter-open.webp'
import PowerBoxOpen from '@/assets/images/mystery-boxes/power-open.webp'
import MasterBoxOpen from '@/assets/images/mystery-boxes/master-open.webp'
import EliteBoxOpen from '@/assets/images/mystery-boxes/elite-open.webp'
import LegendaryBoxOpen from '@/assets/images/mystery-boxes/legendary-open.webp'

export interface MysteryBoxImages {
  closed: string
  open: string
}

export const MYSTERY_BOX_IMAGES: Record<MYSTERY_BOX_TYPE, MysteryBoxImages> = {
  [MYSTERY_BOX_TYPE.FREE]: { closed: FreeBoxClosed, open: FreeBoxOpen },
  [MYSTERY_BOX_TYPE.STARTER]: { closed: StarterBoxClosed, open: StarterBoxOpen },
  [MYSTERY_BOX_TYPE.POWER]: { closed: PowerBoxClosed, open: PowerBoxOpen },
  [MYSTERY_BOX_TYPE.MASTER]: { closed: MasterBoxClosed, open: MasterBoxOpen },
  [MYSTERY_BOX_TYPE.ELITE]: { closed: EliteBoxClosed, open: EliteBoxOpen },
  [MYSTERY_BOX_TYPE.LEGENDARY]: { closed: LegendaryBoxClosed, open: LegendaryBoxOpen },
}
